const cellNames = {
  users: ["ردیف", "نام", "نام خانوادگی", "شماره تلفن"],
  userProfile: ["ردیف", "شماره سفارش", "تاریخ سفارش", " قیمت کل"],
  orders: ["ردیف", "نام", "نام خانوادگی", "شماره سفارش", "تاریخ سفارش"],
  factor: ["ردیف", "کالا", "تعداد", "قیمت فی (ریال)", "قیمت کل (ریال)"],
  branch: ["ردیف", "نام شعبه", "آدرس"],
  common_question: ["ردیف", "پرسش", "پاسخ"],
  discount: ["ردیف", "کد تخفیف", "مقدار", "نوع", "تاریخ انقضا", ""],
  product_stats: ["ردیف", "نام محصول", "دفعات سفارش", "تعداد فروش"],
  home_product: ["ردیف", "نام محصول", "دسته بندی"],
  // products: ["ردیف","عکس" , "نام محصول" , "سردسته" , "قیمت","موجودی"],
  products: ["ردیف", "نام محصول", "سردسته", "قیمت", "موجودی"],
  admins: ["ردیف", "نام", "نام خانوادگی", "نام کاربری"],
  users_list: [
    "ردیف",
    "نام و نام خانوادگی",
    "شماره تماس",
    "ایمیل",
    "تاریخ تولد",
    "ویرایش",
  ],
  catalogs_list: [
    "ردیف",
    "کد پیگیری",
    "نام و نام خانوادگی",
    "شماره تلفن",
    "نام شرکت",
    "سمت",
    "ایمیل",
    "مشاهده",
  ],
  products_list: ["ردیف", "نام محصول", "سردسته", "زیردسته", "ویرایش"],
  products_category_list: ["ردیف", "عنوان", "زیردسته ها", "ویرایش"],
  products_subcategory_list: ["ردیف", "عنوان", "ویرایش"],
  services_list: ["ردیف", "عنوان", "سردسته", "زیردسته", "ویرایش"],
  articles_list: ["ردیف", "عنوان", "سردسته", "تاریخ", "ویرایش"],
  education_list: ["ردیف", "عنوان", "سردسته", "تاریخ", "ویرایش"],
  services_subcategory_list: ["ردیف", "عنوان", "سردسته", "ویرایش"],
  articles_category_list: ["ردیف", "عنوان", "ویرایش"],
  education_category_list: ["ردیف", "عنوان", "ویرایش"],
  records_subcategory_list: ["ردیف", "عنوان", "ویرایش"],
  work_samples_category_list: ["ردیف", "عنوان", "ویرایش"],
  user_list_message: [
    "ردیف",
    "نام و نام خانوادگی",
    "شماره تماس",
    "ایمیل",
    "تاریخ تولد",
  ],
  work_samples_list: ["ردیف", "عنوان", "ویرایش"],
};

export default function generateHeadCells(pageName) {
  return cellNames[pageName].map((items, index) => ({
    id: `${pageName} headCell ${index}`,
    numeric: false,
    disableadding: false,
    label: items,
  }));
}
